<script>
  import DialogContent from "../../dialog/DialogContent.svelte";
  import Button from "../../button/Button.svelte";
  import {translate} from "../../../i18n/i18next.js";
  import {useMe} from "../../../hooks/useMe.js";
  import {useProject} from "../../../hooks/useProject.js";
  import DialogBottomControls from "../../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../dialog/DialogBottomControlButton.svelte";

  export let projectId
  export let invitationId
  export let closeDialog

  const me = useMe()
  const project = useProject(projectId)

  const {origin, hostname} = new URL(window.location)
  const displayInvitationLinkLoopBackAddressWarning = hostname.startsWith("localhost") || hostname.startsWith("127.0.0.1")
  const newUserInvitationLink = origin + `/signup?invitation=${invitationId}`

  function createInvitationMessage() {
    return translate("frontend:pages:projects.project.admin.sections.users.invitationDialog.invitationMessage", null, {
      userName: $me.name,
      userId: $me.id,
      projectName: $project.name,
      projectId: $project.id,
      invitationLink: newUserInvitationLink,
    })
  }
</script>

<DialogContent>
  {#if displayInvitationLinkLoopBackAddressWarning}
    <div
      class="invitation-link-warning-message">{translate("frontend:pages:projects.project.admin.sections.users.invitationDialog.sections.newUser.loopBackAddressWarning")}</div>
  {/if}
  <div class="invitation-container">
    <textarea class="input-invitation-message" id="input-invitation-message">
      {createInvitationMessage()}
    </textarea>
    <div class="buttons-container">
      <Button type="primary" onClick={() => {
        document.querySelector("textarea#input-invitation-message").focus()
        document.querySelector("textarea#input-invitation-message").select()
        document.execCommand("copy")
      }}>
        {translate("generic.copy")}
      </Button>
    </div>
  </div>
</DialogContent>
<DialogBottomControls>
  <DialogBottomControlButton type="secondary" onClick={() => closeDialog()}>
    {translate("generic.close")}
  </DialogBottomControlButton>
</DialogBottomControls>

<style>
  .invitation-container {
    width: 90%;
    align-self: center;
    border-top: 1px solid lightgrey;
    padding-top: 0.3rem;
    margin-top: 0.3rem;
  }

  .input-invitation-message {
    padding: 0.2rem;
    width: 100%;
    min-height: 10rem;
  }

  .buttons-container {
    display: flex;
    justify-content: end;
    gap: 1rem;
  }

  .invitation-link-warning-message {
    padding: 0.5rem 1rem;
    margin: 0.5rem 0;
    font-size: 0.9rem;
    color: #a65403;
    background-color: #fff4e5;
  }
</style>